import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfigurationService } from '../configuration.service';

@Component({
  selector: 'app-user-invite-dialog',
  templateUrl: './user-invite-dialog.component.html',
  styleUrls: ['../configuration-form.css'],
})
export class UserInviteDialogComponent {
  form: FormGroup;
  submitting = false;
  emailError = '';

  constructor(
    private fb: FormBuilder,
    private api: ConfigurationService,
    private dialogRef: MatDialogRef<UserInviteDialogComponent>
  ) {
    this.form = this.fb.group({
      emailAddress: ['', [Validators.required, Validators.email, Validators.maxLength(256)]],
    });
  }

  submit(): void {
    if (this.form.invalid || this.submitting) return;
    this.submitting = true;
    this.emailError = '';

    this.api.inviteUser(this.form.value.emailAddress).subscribe({
      next: () => this.dialogRef.close({ invited: true }),
      error: err => {
        this.submitting = false;
        this.emailError = err.status === 409
          ? 'This email address is already in use'
          : 'Failed to send invite, please try again';
      },
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
